// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__vw6aK","heroImage":"Hero_heroImage__IoFTx","overlayGradient":"Hero_overlayGradient__Y-5Y9","heroTitle":"Hero_heroTitle__FaW1d"};